import './builderPreloader.css';

const Preloader = ({ 
  isLoading = true, 
  isExiting = false,
  title = "Property Builder", 
  stage = "Loading...", 
  progress = 0,
  tips = "💡 Tip: You can drag and drop fields to reorder them"
}) => {
  if (!isLoading) return null;

  return (
    <div className={`hvnly-preloader-container ${isExiting ? 'exiting' : ''}`}>
      <div className="hvnly-preloader-content">
        {/* Elegant Spinner */}
        <div className="hvnly-preloader-spinner">
          <div className="hvnly-spinner-circle"></div>
        </div>
        
        {/* Content */}
        <div className="hvnly-preloader-info">
          <h2 className="hvnly-preloader-title">{title}</h2>
          <p className="hvnly-preloader-stage">{stage}</p>
          
          {/* Minimal Progress */}
          <div className="hvnly-progress-container">
            <div className="hvnly-progress-track">
              <div 
                className="hvnly-progress-bar" 
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <span className="hvnly-progress-text">{Math.round(progress)}%</span>
          </div>
        </div>
        
        {/* Subtle Tips */}
        <div className="hvnly-preloader-tips">
          <p>{tips}</p>
        </div>
      </div>
    </div>
  );
};

export default Preloader;